
import React, { useState } from 'react';
import EditorialLayout from '@/components/editorial/EditorialLayout';
import BookingHeader from '@/components/booking/BookingHeader';
import BookingCalendar from '@/components/booking/BookingCalendar';
import BookingList from '@/components/booking/BookingList';
import BookingStats from '@/components/booking/BookingStats';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { mockBookings } from '@/data/mockBookings';
import { Booking } from '@/types/booking';
import { toast } from 'sonner';

const BookingPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [filter, setFilter] = useState('all');
  
  const handleDeleteBooking = (id: string) => {
    toast.success(`Booking ${id} marked for deletion`);
    // In a real app, this would call an API
  };
  
  const handleEditBooking = (booking: Booking) => {
    toast.info(`Editing booking for ${booking.companyName}`);
    // In a real app, this would open an edit form
  };
  
  const handleViewBooking = (booking: Booking) => {
    toast.info(`Viewing details for ${booking.companyName}`);
    // In a real app, this would show detailed view
  };

  return (
    <EditorialLayout>
      <div className="max-w-7xl mx-auto px-4 py-6">
        <BookingHeader />
        
        <div className="mt-8">
          <Tabs defaultValue="kalender" className="w-full">
            <TabsList>
              <TabsTrigger value="kalender">Kalender</TabsTrigger>
              <TabsTrigger value="liste">Bookingliste</TabsTrigger>
              <TabsTrigger value="statistikk">Statistikk</TabsTrigger>
            </TabsList>
            
            <TabsContent value="kalender" className="mt-6">
              <BookingCalendar />
            </TabsContent>
            
            <TabsContent value="liste" className="mt-6">
              <BookingList 
                bookings={mockBookings} 
                isLoading={isLoading}
                onDeleteBooking={handleDeleteBooking}
                onEditBooking={handleEditBooking}
                onViewBooking={handleViewBooking}
                filter={filter}
              />
            </TabsContent>
            
            <TabsContent value="statistikk" className="mt-6">
              <BookingStats />
            </TabsContent>
          </Tabs>
        </div>
      </div>
    </EditorialLayout>
  );
};

export default BookingPage;
